import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Box, Typography, Button, Grid } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import AddIcon from "@mui/icons-material/Add";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "bootstrap/dist/css/bootstrap.min.css";
import Navbar from "../../../../Home/Components/Nav";
import Footer from "../../../../Home/Components/Footer";
import Contactus from "../../../../contact/Container/Contactformcon";

/* =========================================================================
   PLACEHOLDER ASSETS
   Replace every URL below with the real Hector Tomahawk PHEV media. The
   whole page is wired to these constants, so swapping a link here updates
   every place that asset is used.
   ========================================================================= */
const PLACEHOLDER_IMG =
  "https://mgmotor.scene7.com/is/image/mgmotor/004-phev-product-bn?wid=2560&fmt=webp-alpha&resMode=bisharp&fit=constrain&qlt=80";

// Section 1 — Hero (the banner art already has the logo/title/price baked in)
const HERO_IMG_DESKTOP = "https://mgmotor.scene7.com/is/image/mgmotor/004-phev-product-bn?wid=2560&fmt=webp-alpha&resMode=bisharp&fit=constrain&qlt=80"; // "Introducing Hector Tomahawk PHEV" banner (landscape)
const HERO_IMG_MOBILE = "https://mgmotor.scene7.com/is/image/mgmotor/004-phev-product-bn-portrait?wid=750&fmt=webp-alpha&resMode=bisharp&fit=constrain&qlt=80"; // same banner, portrait/mobile crop

// Section 2 — Drive modes
const DRIVE_MODE_DIRECT_IMG = "https://firebasestorage.googleapis.com/v0/b/mgcentral-a28cf.firebasestorage.app/o/hector-tomahawk%2F001-direct-mode-image.webp?alt=media&token=7fee90d9-40a3-48eb-b359-9660607ba0eb";
const DRIVE_MODE_EV_IMG = "https://firebasestorage.googleapis.com/v0/b/mgcentral-a28cf.firebasestorage.app/o/hector-tomahawk%2F002-ev-mode-image.webp?alt=media&token=7fee90d9-40a3-48eb-b359-9660607ba0eb";
const DRIVE_MODE_PARALLEL_IMG = "https://firebasestorage.googleapis.com/v0/b/mgcentral-a28cf.firebasestorage.app/o/hector-tomahawk%2F003-parallel-mode-image.webp?alt=media&token=7fee90d9-40a3-48eb-b359-9660607ba0eb";
const DRIVE_MODE_SERIES_IMG = "https://firebasestorage.googleapis.com/v0/b/mgcentral-a28cf.firebasestorage.app/o/hector-tomahawk%2F004-series-mode-image.webp?alt=media&token=7fee90d9-40a3-48eb-b359-9660607ba0eb";

const DRIVE_MODES = [
  { key: "direct", label: "Direct Mode", title: "Direct Mode", desc: "Smooth, confident power for effortless everyday drives.", image: DRIVE_MODE_DIRECT_IMG },
  { key: "ev", label: "EV Mode", title: "Pure EV Mode", desc: "Quiet, clean performance for effortless driving on your everyday city journeys.", image: DRIVE_MODE_EV_IMG },
  { key: "parallel", label: "Parallel Mode", title: "Parallel Mode", desc: "Balanced performance when you want power and efficiency together.", image: DRIVE_MODE_PARALLEL_IMG },
  { key: "series", label: "Series Mode", title: "Series Mode", desc: "Effortless electric performance for relaxed, seamless travel.", image: DRIVE_MODE_SERIES_IMG },
];

// Section 3 — Intelligent Hybrid Powertrain (hotspot diagram)
const POWERTRAIN_BG_IMG = "https://firebasestorage.googleapis.com/v0/b/mgcentral-a28cf.firebasestorage.app/o/hector-tomahawk%2F004-hotspot-image.webp?alt=media&token=e3c4d3ae-2248-432f-b248-c189b034d047";
const HOTSPOT_ENGINE_IMG = "https://firebasestorage.googleapis.com/v0/b/mgcentral-a28cf.firebasestorage.app/o/hector-tomahawk%2F001-mg-starlight-hotspot-banner-modal-landscape.webp?alt=media&token=b6f1b986-5589-4a26-832e-51e122d8509a";
const HOTSPOT_DRIVE_UNIT_IMG = "https://firebasestorage.googleapis.com/v0/b/mgcentral-a28cf.firebasestorage.app/o/hector-tomahawk%2F002-mg-starlight-hotspot-banner-modal-landscape.webp?alt=media&token=b6f1b986-5589-4a26-832e-51e122d8509a";
const HOTSPOT_BATTERY_IMG = "https://firebasestorage.googleapis.com/v0/b/mgcentral-a28cf.firebasestorage.app/o/hector-tomahawk%2F003-mg-starlight-hotspot-banner-modal-landscape.webp?alt=media&token=b6f1b986-5589-4a26-832e-51e122d8509a";
const HOTSPOT_DHT_IMG = "https://firebasestorage.googleapis.com/v0/b/mgcentral-a28cf.firebasestorage.app/o/hector-tomahawk%2F004-mg-starlight-hotspot-banner-modal-landscape.webp?alt=media&token=b6f1b986-5589-4a26-832e-51e122d8509a";

const POWERTRAIN_HOTSPOTS = [
  { key: "engine", left: "40%", top: "56%", leftMobile: "22%", topMobile: "52%", title: "Dedicated Hybrid Engine", desc: "Delivers an industry-leading 43.2% thermal efficiency, maximising every drop of fuel while seamlessly supporting electric drive.", image: HOTSPOT_ENGINE_IMG },
  { key: "driveUnit", left: "45.5%", top: "60%", leftMobile: "38%", topMobile: "62%", title: "10-in-1 Intelligent Drive Unit", desc: "Integrates ten critical functions into one intelligent unit, improving efficiency, reliability and system responsiveness.", image: HOTSPOT_DRIVE_UNIT_IMG },
  { key: "battery", left: "53.5%", top: "61%", leftMobile: "58%", topMobile: "62%", title: "Dedicated Battery System", desc: "Purpose-built to intelligently manage energy flow and maximise hybrid efficiency across every journey.", image: HOTSPOT_BATTERY_IMG },
  { key: "dht", left: "65%", top: "56%", leftMobile: "78%", topMobile: "52%", title: "World's First Electromagnetic DHT", desc: "Delivers 98.8% transmission efficiency with ultra-fast 0.1-second mode switching for intelligent and seamless power delivery.", image: HOTSPOT_DHT_IMG },
];

// Section 4 — Panoramic sunroof (with a sunroof/seats view toggle)
const SUNROOF_VIEW_IMG_DESKTOP = "https://mgmotor.scene7.com/is/image/mgmotor/004-interior-image?wid=2560&fmt=webp-alpha&resMode=bisharp&fit=constrain&qlt=80";
const SUNROOF_VIEW_IMG_MOBILE = "https://firebasestorage.googleapis.com/v0/b/mgcentral-a28cf.firebasestorage.app/o/hector-tomahawk%2F002-interior-image-portrait.webp?alt=media&token=3be5223d-a6ff-4f56-835f-4ed0c013f4f0";
const SEATS_VIEW_IMG_DESKTOP = "https://mgmotor.scene7.com/is/image/mgmotor/005-interior-image?wid=2560&fmt=webp-alpha&resMode=bisharp&fit=constrain&qlt=80";
const SEATS_VIEW_IMG_MOBILE = "https://firebasestorage.googleapis.com/v0/b/mgcentral-a28cf.firebasestorage.app/o/hector-tomahawk%2F001-interior-image-portrait.webp?alt=media&token=3be5223d-a6ff-4f56-835f-4ed0c013f4f0";

// Section 5 — "7-Seater. More Space for Everyone." (background video)
const SEVEN_SEATER_VIDEO_DESKTOP = "https://mgmotor.scene7.com/is/content/mgmotor/001-feature-video";
const SEVEN_SEATER_VIDEO_MOBILE = "https://mgmotor.scene7.com/is/content/mgmotor/001-feature-video-portrait";
const SEVEN_SEATER_POSTER_IMG = PLACEHOLDER_IMG; // shown until the video's first frame is ready

// Section 6 — "A Presence That's Hard to Miss" slider
const PRESENCE_SLIDE1_IMG = "https://firebasestorage.googleapis.com/v0/b/mgcentral-a28cf.firebasestorage.app/o/hector-tomahawk%2F001-interior-image.webp?alt=media&token=1ae74905-ff59-4a83-88ac-8bec5eb3b7a2"; // AERONAUTIC ALLOYS
const PRESENCE_SLIDE2_IMG = "https://firebasestorage.googleapis.com/v0/b/mgcentral-a28cf.firebasestorage.app/o/hector-tomahawk%2F002-interior-image.webp?alt=media&token=1ae74905-ff59-4a83-88ac-8bec5eb3b7a2"; // COMMANDING ROAD PRESENCE
const PRESENCE_SLIDE3_IMG = "https://firebasestorage.googleapis.com/v0/b/mgcentral-a28cf.firebasestorage.app/o/hector-tomahawk%2F003-interior-image.webp?alt=media&token=1ae74905-ff59-4a83-88ac-8bec5eb3b7a2"; // SCULPTED SILHOUETTE

const PRESENCE_SLIDES = [
  { image: PRESENCE_SLIDE1_IMG, title: "HAWK X​", desc: "A striking 3D grille for a distinctive, futuristic look.​" },
  { image: PRESENCE_SLIDE2_IMG, title: "AERONAUTIC ALLOYS​", desc: "Aerodynamic contours inspired by the Tomahawk.​" },
  { image: PRESENCE_SLIDE3_IMG, title: "COMMANDING ROAD PRESENCE​", desc: "Tall, wide and confidently proportioned to command attention." },
];

// Section 7 — Request a Callback banner
const CALLBACK_BANNER_IMG = PLACEHOLDER_IMG;
/* ========================================================================= */

const sectionHeading = {
  fontFamily: "'Poppins', Arial, sans-serif",
  fontWeight: 600,
  textAlign: "center",
  fontSize: { xs: "24px", md: "34px" },
  color: "#111",
};

const sectionSubtext = {
  textAlign: "center",
  color: "#555",
  fontSize: { xs: "13px", md: "15px" },
  maxWidth: "620px",
  margin: "10px auto 0",
};

/* Custom pill-style dots, matching the MG official carousel look */
const featureDotsCSS = `
.phev-slider .slick-slide,
.phev-slider .slick-slide div,
.phev-slider .slick-slide:focus,
.phev-slider .slick-track,
.phev-slider .slick-list {
  outline: none;
}
`;

/* Reusable feature-card slider for section 6 */
class FeatureSlider extends Component {
  constructor(props) {
    super(props);
    this.state = { current: 0 };
    this.sliderRef = React.createRef();
  }

  render() {
    const { slides } = this.props;
    const { current } = this.state;
    const settings = {
      dots: false,
      arrows: false,
      infinite: true,
      speed: 500,
      slidesToShow: 2.3,
      slidesToScroll: 1,
      beforeChange: (_, next) => this.setState({ current: next }),
      responsive: [{ breakpoint: 900, settings: { slidesToShow: 1.1, infinite: false } }],
    };
    return (
      <Box sx={{ width: "100%", margin: "30px auto 0", px: 0, position: "relative" }} className="phev-slider">
        <style>{featureDotsCSS}</style>
        <Slider ref={this.sliderRef} {...settings}>
          {slides.map((s, i) => (
            <Box key={i} sx={{ px: 1 }}>
              <Box
                component="img"
                src={s.image}
                alt={s.title}
                loading="lazy"
                decoding="async"
                sx={{ width: "100%", height: { xs: "180px", md: "340px" }, objectFit: "cover", borderRadius: "4px", backgroundColor: "#eee" }}
              />
              <Typography sx={{ fontWeight: 700, fontSize: "16px", mt: 2, letterSpacing: "0.3px" }}>{s.title}</Typography>
              <Typography sx={{ fontSize: "14px", color: "#666", mt: 0.5 }}>{s.desc}</Typography>
            </Box>
          ))}
        </Slider>
        <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", gap: "6px", mt: 2.5 }}>
          {slides.map((_, i) => (
            <Box
              key={i}
              onClick={() => this.sliderRef.current && this.sliderRef.current.slickGoTo(i)}
              sx={{
                width: current === i ? "22px" : "8px",
                height: "8px",
                borderRadius: "5px",
                backgroundColor: current === i ? "#d62e2e" : "#f4c9c8",
                cursor: "pointer",
                transition: "all 0.3s ease",
              }}
            />
          ))}
        </Box>
      </Box>
    );
  }
}

class HectorTomahawkPhev extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeDriveMode: "direct",
      activeHotspot: null, // hotspot key | null
      sunroofView: "sunroof", // "sunroof" | "seats"
    };
  }

  render() {
    const { activeDriveMode, activeHotspot, sunroofView } = this.state;
    const currentMode = DRIVE_MODES.find((m) => m.key === activeDriveMode) || DRIVE_MODES[0];
    const currentHotspot = POWERTRAIN_HOTSPOTS.find((h) => h.key === activeHotspot);

    return (
      <div id="container">
        <Navbar />

        {/* ================= 1. HERO SECTION ================= */}
        <Box sx={{ position: "relative", width: "100%", height: "100vh", backgroundColor: "#000", overflow: "hidden" }}>
          <Box
            component="img"
            src={HERO_IMG_MOBILE}
            alt="Hector Tomahawk PHEV"
            loading="eager"
            fetchpriority="high"
            sx={{ width: "100%", height: "100%", objectFit: "cover", objectPosition: "top center", display: { xs: "block", md: "none" } }}
          />
          <Box
            component="img"
            src={HERO_IMG_DESKTOP}
            alt="Hector Tomahawk PHEV"
            loading="eager"
            fetchpriority="high"
            sx={{ width: "100%", height: "100%", objectFit: "cover", objectPosition: "top center", display: { xs: "none", md: "block" } }}
          />

          {/* Bottom-left CTA buttons */}
          <Box sx={{ position: "absolute", left: { xs: "16px", md: "56px" }, bottom: { xs: "16px", md: "40px" }, display: "flex", gap: "12px" }}>
            <Link to="/connect" style={{ textDecoration: "none" }}>
              <Button variant="outlined" sx={{ backgroundColor: "#fff", color: "#111", borderColor: "#fff", fontWeight: 600, borderRadius: "2px", px: 2.5, "&:hover": { backgroundColor: "#eee", borderColor: "#eee" } }}>
                BOOK TEST DRIVE
              </Button>
            </Link>
            <Link to="/connect" style={{ textDecoration: "none" }}>
              <Button variant="contained" sx={{ backgroundColor: "#794F36", fontWeight: 600, borderRadius: "2px", px: 2.5, "&:hover": { backgroundColor: "#5c3a26" } }}>
                BOOK NOW
              </Button>
            </Link>
          </Box>
        </Box>

        {/* Breadcrumb */}
        <Box sx={{ height: "40px", mt: 1, ml: { xs: "16px", md: "50px" } }}>
          <Link to="/" style={{ textDecoration: "none", color: "grey" }}>
            <b>Home</b>
          </Link>
          <Link to="/HectorTomahawkPhev" style={{ textDecoration: "none", color: "grey" }}>
            &nbsp;&nbsp;MG Hector Tomahawk PHEV
          </Link>
        </Box>

        {/* ================= 2. DRIVE MODES SECTION ================= */}
        <Box sx={{ py: { xs: 3, md: 5 } }}>
          <Typography sx={sectionHeading}>{currentMode.title}</Typography>
          <Typography sx={sectionSubtext}>{currentMode.desc}</Typography>

          <Box
            component="img"
            src={currentMode.image}
            alt={currentMode.title}
            loading="lazy"
            decoding="async"
            sx={{ display: "block", width: { xs: "85%", md: "45%" }, maxWidth: "620px", mx: "auto", mt: { xs: 3, md: 5 } }}
          />

          <Box sx={{ display: "flex", justifyContent: "center", gap: { xs: 1, md: 2 }, mt: 4, flexWrap: "wrap", px: 2 }}>
            {DRIVE_MODES.map((mode) => (
              <Box
                key={mode.key}
                onClick={() => this.setState({ activeDriveMode: mode.key })}
                sx={{
                  px: 3,
                  py: 1,
                  borderRadius: "24px",
                  fontSize: "14px",
                  fontWeight: 600,
                  cursor: "pointer",
                  backgroundColor: activeDriveMode === mode.key ? "#111" : "transparent",
                  color: activeDriveMode === mode.key ? "#fff" : "#333",
                  border: activeDriveMode === mode.key ? "none" : "1px solid transparent",
                }}
              >
                {mode.label}
              </Box>
            ))}
          </Box>
        </Box>

        {/* ================= 3. INTELLIGENT HYBRID POWERTRAIN (HOTSPOTS) ================= */}
        <Box sx={{ position: "relative", width: "100%", height: { xs: "60vh", md: "95vh" }, backgroundColor: "#000" }}>
          <Box component="img" src={POWERTRAIN_BG_IMG} alt="Intelligent Hybrid Powertrain" loading="lazy" decoding="async" sx={{ width: "100%", height: "100%", objectFit: "cover", display: "block" }} />

          <Box sx={{ position: "absolute", top: { xs: "20px", md: "40px" }, left: 0, right: 0, textAlign: "center", px: 2 }}>
            <Typography sx={{ ...sectionHeading, color: "#fff" }}>Intelligent Hybrid Powertrain</Typography>
            <Typography sx={{ ...sectionSubtext, color: "rgba(255,255,255,0.85)" }}>
              Built to intelligently optimize power delivery across EV, Hybrid and Boost models for seamless efficiency in every drive.
            </Typography>
          </Box>

          <Box sx={{ position: "absolute", inset: 0 }}>
            {POWERTRAIN_HOTSPOTS.map((h) => (
              <Box
                key={h.key}
                onClick={() => this.setState({ activeHotspot: activeHotspot === h.key ? null : h.key })}
                sx={{
                  position: "absolute",
                  left: { xs: h.leftMobile, md: h.left },
                  top: { xs: h.topMobile, md: h.top },
                  width: { xs: "26px", md: "36px" },
                  height: { xs: "26px", md: "36px" },
                  borderRadius: "50%",
                  backgroundColor: "#d62e2e",
                  color: "#fff",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  cursor: "pointer",
                  boxShadow: "0 0 0 6px rgba(214,46,46,0.3)",
                  transform: "translate(-50%, -50%)",
                  zIndex: 2,
                }}
              >
                <AddIcon fontSize="small" />
              </Box>
            ))}

            {currentHotspot && (
              <Box
                sx={{
                  position: "absolute",
                  top: { xs: "10px", md: currentHotspot.top },
                  ...(parseFloat(currentHotspot.left) < 55
                    ? { left: { xs: "10px", md: `calc(${currentHotspot.left} + 30px)` } }
                    : { right: { xs: "10px", md: `calc(${100 - parseFloat(currentHotspot.left)}% + 30px)` } }),
                  transform: { xs: "none", md: "translateY(-30%)" },
                  width: { xs: "calc(100% - 20px)", sm: "340px" },
                  maxHeight: { xs: "calc(100% - 20px)", md: "70vh" },
                  backgroundColor: "#fff",
                  borderRadius: "8px",
                  p: { xs: 2, md: 3 },
                  overflowY: "auto",
                  zIndex: 3,
                }}
              >
                <Box onClick={() => this.setState({ activeHotspot: null })} sx={{ cursor: "pointer", display: "inline-flex", mb: 1.5 }}>
                  <CloseIcon />
                </Box>
                <Box component="img" src={currentHotspot.image} alt={currentHotspot.title} sx={{ width: "100%", borderRadius: "4px", backgroundColor: "#f2f2f2", display: "block" }} />
                <Typography sx={{ fontSize: { xs: "20px", md: "26px" }, fontWeight: 700, mt: 2 }}>{currentHotspot.title}</Typography>
                <Typography sx={{ fontSize: "14px", color: "#555", mt: 1.5 }}>{currentHotspot.desc}</Typography>
              </Box>
            )}
          </Box>
        </Box>

        {/* ================= 4. PANORAMIC SUNROOF ================= */}
        <Box sx={{ position: "relative", width: "100%", height: { xs: "55vh", md: "85vh" }, backgroundColor: "#000" }}>
          <Box
            component="img"
            src={sunroofView === "sunroof" ? SUNROOF_VIEW_IMG_MOBILE : SEATS_VIEW_IMG_MOBILE}
            alt="Panoramic Sunroof"
            loading="lazy"
            decoding="async"
            sx={{ width: "100%", height: "100%", objectFit: "cover", display: { xs: "block", md: "none" } }}
          />
          <Box
            component="img"
            src={sunroofView === "sunroof" ? SUNROOF_VIEW_IMG_DESKTOP : SEATS_VIEW_IMG_DESKTOP}
            alt="Panoramic Sunroof"
            loading="lazy"
            decoding="async"
            sx={{ width: "100%", height: "100%", objectFit: "cover", display: { xs: "none", md: "block" } }}
          />
          <Box
            sx={{
              position: "absolute",
              left: "50%",
              bottom: { xs: "16px", md: "32px" },
              transform: "translateX(-50%)",
              display: "flex",
              gap: { xs: "6px", md: "10px" },
              backgroundColor: "rgba(255,255,255,0.35)",
              backdropFilter: "blur(6px)",
              borderRadius: { xs: "16px", md: "22px" },
              p: { xs: "6px", md: "10px" },
            }}
          >
            {[
              { key: "sunroof", img: SUNROOF_VIEW_IMG_DESKTOP },
              { key: "seats", img: SEATS_VIEW_IMG_DESKTOP },
            ].map((t) => (
              <Box
                key={t.key}
                onClick={() => this.setState({ sunroofView: t.key })}
                component="img"
                src={t.img}
                alt={t.key}
                sx={{
                  width: { xs: "68px", md: "110px" },
                  height: { xs: "50px", md: "80px" },
                  objectFit: "cover",
                  borderRadius: { xs: "10px", md: "14px" },
                  cursor: "pointer",
                  outline: sunroofView === t.key ? "2px solid #fff" : "2px solid transparent",
                  outlineOffset: "2px",
                }}
              />
            ))}
          </Box>
        </Box>

        {/* ================= 5. 7-SEATER BANNER ================= */}
        <Box sx={{ position: "relative", width: "100%", height: { xs: "45vh", md: "75vh" }, backgroundColor: "#000", overflow: "hidden" }}>
          <video autoPlay muted loop playsInline poster={SEVEN_SEATER_POSTER_IMG} style={{ width: "100%", height: "100%", objectFit: "cover", display: "block" }}>
            <source src={SEVEN_SEATER_VIDEO_MOBILE} media="(max-width: 767px)" type="video/mp4" />
            <source src={SEVEN_SEATER_VIDEO_DESKTOP} type="video/mp4" />
          </video>

          <Typography
            sx={{
              position: "absolute",
              top: { xs: "24px", md: "48px" },
              left: { xs: "16px", md: "56px" },
              color: "#fff",
              fontWeight: 500,
              fontSize: { xs: "26px", md: "40px" },
              maxWidth: "480px",
            }}
          >
            7-Seater. More Space for Everyone.
          </Typography>

          <Box
            sx={{
              position: "absolute",
              left: 0,
              right: 0,
              bottom: { xs: "16px", md: "32px" },
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              gap: { xs: 2, md: 5 },
              flexWrap: "wrap",
            }}
          >
            {["7-SEATER", "3 ROWS", "GENEROUS LEGROOM"].map((t, i, arr) => (
              <React.Fragment key={t}>
                <Typography sx={{ fontSize: { xs: "12px", md: "15px" }, color: "#fff", fontWeight: 500 }}>{t}</Typography>
                {i < arr.length - 1 && <Box sx={{ width: "1px", height: "16px", backgroundColor: "rgba(255,255,255,0.5)" }} />}
              </React.Fragment>
            ))}
          </Box>
        </Box>

        {/* ================= 6. "A PRESENCE THAT'S HARD TO MISS" SLIDER ================= */}
        <Box sx={{ py: { xs: 4, md: 6 } }}>
          <Typography sx={sectionHeading}>A Presence That's Hard to Miss</Typography>
          <Typography sx={sectionSubtext}>Bold design and commanding proportions, crafted to make an unmistakable impression.</Typography>
          <FeatureSlider slides={PRESENCE_SLIDES} />
        </Box>

        {/* ================= 7. REQUEST A CALLBACK ================= */}
        <Box sx={{ py: { xs: 4, md: 6 }, px: { xs: 2, md: 6 } }}>
          <Grid container spacing={4} alignItems="center">
            <Grid item xs={12} md={6}>
              <Contactus someValue="Hector Tomahawk PHEV" />
            </Grid>
            <Grid item xs={12} md={6}>
              <Box component="img" src={CALLBACK_BANNER_IMG} alt="Hector Tomahawk PHEV" loading="lazy" decoding="async" sx={{ width: "100%", borderRadius: "4px", display: "block" }} />
            </Grid>
          </Grid>
        </Box>

        <Footer />
      </div>
    );
  }
}

export default HectorTomahawkPhev;
